// extracted by mini-css-extract-plugin
export default {"container":"collections-page_container__2x4Ag","menuLabel":"collections-page_menuLabel__2k0Xy","filters":"collections-page_filters__1-Fyv"};